/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { GuestCounter } from 'sarsaparilla';
import { readMaxGroupSizeRule } from '../constants/registration';

export default function GroupSizeSelector({
    permit,
    permitType,
    isLabelVisible = true,
    value,
    onChange,
}) {
    const { id, rules } = permit;
    const maxGroupSize = readMaxGroupSizeRule(id, permitType, rules);

    if (value > maxGroupSize) {
        onChange(maxGroupSize);
    }

    return (
        <>
            {isLabelVisible && <label htmlFor="guest-counter">Group Size</label>}
            <GuestCounter
                title="Members"
                minTotalGuests={1}
                maxTotalGuests={maxGroupSize}
                guestTypes={[
                    {
                        key: 'member',
                        type: 'Member',
                        count: value,
                    },
                ]}
                onCountChange={({ member: groupSize }) => onChange(groupSize)}
            />
        </>
    );
}

GroupSizeSelector.propTypes = {
    permit: PropTypes.object,
    permitType: PropTypes.string,
    isLabelVisible: PropTypes.bool,
    value: PropTypes.number,
    onChange: PropTypes.func,
};
